import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';
import { nucleusConstants } from '@lifesize/nucleus';
import Divider from '@material-ui/core/Divider';
import ContactDetailsBlock from 'containers/ContactDetailsBlock/ContactDetailsBlockContainer';
import SharingBlock from './SharingBlock';
import MeetingLock from './MeetingLock';
import classes from './CallDetails.module.scss';

export class CallDetails extends React.Component {
  UNSAFE_componentWillUpdate(nextProps) {
    if (!nextProps.contact) {
      this.props.closeInCallDrawer();
    }
  }

  isConferenceVmr = () => this.props.conference.type === nucleusConstants.GALAXY_CONFERENCE_TYPE_VMR;

  render() {
    const { callDisplayName, contact, isModerator, isVisible, presentationRestrictionEnabled } = this.props;

    return (
      <div className={clsx(classes.container, !isVisible && classes.hiddenDrawer)}>
        <header className={classes.drawerTitle}>
          <FormattedMessage id="components.inCall.meetingInformation.title" defaultMessage="Meeting Information" />
        </header>
        {/* { presentationRestrictionEnabled &&
          <div className={classes.meetingType}>
            <FormattedMessage
              id="components.inCall.meeting.label.permanentMeeting"
              defaultMessage="Permanent Meeting"
          /></div>
        }*/}
        <div className={classes.details}>
          <ContactDetailsBlock callDisplayName={callDisplayName} contact={contact} hideOwner isInCall={true} />
          {isModerator && (
            <>
              <Divider />
              {presentationRestrictionEnabled && this.isConferenceVmr() && <SharingBlock />}
              {this.isConferenceVmr() && <MeetingLock />}
            </>
          )}
        </div>
      </div>
    );
  }
}

CallDetails.propTypes = {
  callDisplayName: PT.array,
  closeInCallDrawer: PT.func,
  contact: PT.object,
  isVisible: PT.bool,
  isInCall: PT.bool,
  presentationRestrictionEnabled: PT.bool.isRequired
};

export default CallDetails;
